
export const ROLE_OWNER = "owner";
export const ROLE_ADMIN = "admin";
export const ROLE_MANAGER = "manager";
export const ROLE_USER = "user";

export const PERM_DEVELOPER = "PERM_DEVELOPER";
export const PERM_PARTNER1 = "PERM_PARTNER1";
export const PERM_PARTNER2 = "PERM_PARTNER2";

export const PERM_CALL_STACK = "PERM_CALL_STACK";
export const PERM_EDIT_CHANNEL_DEF = "PERM_EDIT_CHANNEL_DEF";
export const PERM_EDIT_ORGANISATION = "PERM_EDIT_ORGANISATION";
export const PERM_EDIT_PERMISSIONS = "PERM_EDIT_PERMISSIONS";
export const PERM_ADD_ORGANISATION = "PERM_ADD_ORGANISATION";
export const PERM_EDIT_CHANNEL = "PERM_EDIT_CHANNEL";
export const PERM_EDIT_SCREEN = "PERM_EDIT_SCREEN";
export const PERM_EDIT_INVITATION = "PERM_EDIT_INVITATION";
export const PERM_INSTANCE_ADMIN = "PERM_INSTANCE_ADMIN";
export const PERM_INSTANCE_SUPPORT = "PERM_INSTANCE_SUPPORT";
export const PERM_INSTANCE_DEVELOPER = "PERM_INSTANCE_DEVELOPER";
export const PERM_INSTANCE_VIEW = "PERM_INSTANCE_VIEW";
export const PERM_INSTANCE_BILLING = "PERM_INSTANCE_BILLING";
export const PERM_INSTANCE_USER_ADMIN = "PERM_INSTANCE_USER_ADMIN";
export const PERM_NOBODY_HAS_THAT_PERMISSION = "NOBODY_HAS_THAT_PERMISSION";

export const ROLE_COMPANY_ADMIN = "role-company-admin";
export const ROLE_COMPANY_OWNER = "role-company-owner";
export const ROLE_COMPANY_MANAGER = "role-company-manager";
export const ROLE_COMPANY_USER = "role-company-user";
export const ROLE_DEFAULT = "role-default";
export const ROLE_SYSTEM_ADMIN = "role-system-admin";
export const ROLE_INSTANCE_ADMIN = "ROLE_INSTANCE_ADMIN";
export const ROLE_INSTANCE_SUPPORT = "ROLE_INSTANCE_SUPPORT";
export const ROLE_INSTANCE_DEVELOPER = "ROLE_INSTANCE_DEVELOPER";

export const ADMIN_EDITABLE_PERMISSIONS = [
    PERM_PARTNER1,
    PERM_PARTNER2
];


export const ORGANISATION_PERMISSIONS = {
    PERM_EDIT_ORGANISATION,
    PERM_EDIT_PERMISSIONS,
    PERM_EDIT_CHANNEL,
    PERM_EDIT_SCREEN,
    PERM_EDIT_INVITATION,
};

export const roles = {
    [ROLE_COMPANY_ADMIN]: [
        PERM_EDIT_CHANNEL,
        PERM_EDIT_ORGANISATION,
        PERM_EDIT_PERMISSIONS,
        PERM_EDIT_INVITATION,
        PERM_EDIT_SCREEN,
    ],
    [ROLE_COMPANY_OWNER]: [
        PERM_EDIT_CHANNEL,
        PERM_EDIT_ORGANISATION,
        PERM_EDIT_PERMISSIONS,
        PERM_EDIT_INVITATION,
        PERM_EDIT_SCREEN,
    ],
    [ROLE_COMPANY_MANAGER]: [
        PERM_EDIT_CHANNEL,
        PERM_EDIT_ORGANISATION,
        PERM_EDIT_SCREEN,
    ],
    [ROLE_COMPANY_USER]: [
    ],
    [ROLE_DEFAULT]: [
        PERM_ADD_ORGANISATION,
    ],
    [ROLE_SYSTEM_ADMIN]: [
        PERM_DEVELOPER,
        PERM_CALL_STACK,
        PERM_INSTANCE_ADMIN,
    ],
    [ROLE_INSTANCE_ADMIN]: [
        PERM_INSTANCE_ADMIN,
        PERM_INSTANCE_USER_ADMIN,
        PERM_INSTANCE_VIEW,
        PERM_INSTANCE_DEVELOPER,
        PERM_INSTANCE_BILLING,
        PERM_INSTANCE_SUPPORT,
    ],
    [ROLE_INSTANCE_SUPPORT]: [
        PERM_INSTANCE_USER_ADMIN,
        PERM_INSTANCE_VIEW,
        PERM_INSTANCE_DEVELOPER,
        PERM_INSTANCE_BILLING,
        PERM_INSTANCE_SUPPORT,
    ],
    [ROLE_INSTANCE_DEVELOPER]: [
        PERM_INSTANCE_DEVELOPER,
        PERM_INSTANCE_USER_ADMIN,
        PERM_INSTANCE_VIEW,
        PERM_INSTANCE_DEVELOPER,
        PERM_INSTANCE_SUPPORT,
    ],
};

function hasPermission_(perm, permissionObject) {
    if (permissionObject && permissionObject.globalPermissions && Array.isArray(permissionObject.globalPermissions)) {
        if (permissionObject.globalPermissions.indexOf(perm) !== -1) {
            return true;
        }

        for (let gperm of permissionObject.globalPermissions) {
            /* support for roles */
            if (roles[gperm]) {
                if (hasPermissionInternal(perm, {
                        globalPermissions: roles[gperm]
                    })) {
                    return true;
                }
            }
        }
    }

    return false;
}

export function hasOrganisationPermissionInternal(perm, organisationId, permissionObject) {
    if (hasPermissionInternal(perm, permissionObject)) {
        return true;
    }

    if (perm in ORGANISATION_PERMISSIONS) {
        if (permissionObject && permissionObject.organisationPermissions) {
            let o2u = permissionObject.organisationPermissions.find((o2u) => o2u.organisation_id === organisationId);
            if (o2u) {
                let permission = [];
                if (o2u.permissions) {
                    if (typeof o2u.permissions === 'string') {
                        permission = [...permission, JSON.parse(o2u.permissions)];
                    } else {
                        permission = [...permission, ...o2u.permissions];
                    }
                }
                if (o2u.role === ROLE_ADMIN || o2u.role === '') {
                    permission.push(ROLE_COMPANY_ADMIN);
                } else if (o2u.role === ROLE_OWNER) {
                    permission.push(ROLE_COMPANY_OWNER);
                } else if (o2u.role === ROLE_MANAGER || o2u.role === '') {
                    permission.push(ROLE_COMPANY_MANAGER);
                } else if (o2u.role === ROLE_USER || o2u.role === '') {
                    permission.push(ROLE_COMPANY_USER);
                }

                if (hasPermissionInternal(perm, {globalPermissions: permission})) {
                    return true;
                }
            }
        }
    }

    /* instance user admin can access all organisations */
    if (hasPermissionInternal(PERM_INSTANCE_USER_ADMIN, permissionObject)) {
        let permission = [];
        permission.push(ROLE_COMPANY_ADMIN);

        if (hasPermissionInternal(perm, {globalPermissions: permission})) {
            return true;
        }
    }


    return false;
}

export function hasPermissionInternal(perm, permissionObject) {
    if (hasPermission_(perm, permissionObject)) {
        return true;
    }

    if (hasPermission_(perm, {
            globalPermissions: roles[ROLE_DEFAULT]
        })) {
        return true;
    }

	return false;
}
